<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-等级管理-添加商品
  -->
   <div>
  <el-dialog title="设置股东" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="70%">
    <el-form size="small" :model="form" ref="form">
      <el-form-item :label-width="formLabelWidth" label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item  :label-width="formLabelWidth" label="关联会员" :rules="[{ required: true, message: '请关联会员' }]">
        
          <el-button @click="addClick" icon="el-icon-plus">关联会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img v-if="user_info.avatarUrl" :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>

        <el-button @click="remove" v-if="form.user_id!=''">移除会员</el-button>
      </el-form-item>



      <el-form-item :label-width="formLabelWidth" label="选择商品">
        <RelationProduct :form="form" ></RelationProduct>
      </el-form-item>

      
      <!-- <el-form-item :label-width="formLabelWidth" label="优惠比例">
        <el-radio-group v-model="form.dis_status">
          <el-radio :label="1">固定</el-radio>
          <el-radio :label="2">比例</el-radio>
        </el-radio-group>
         <el-input type="number" v-model="form.discounts"></el-input>
         <div>
            <span v-if="form.dis_status == 1">举例：商品100元，抵扣{{ form.discounts }}元</span>
            <span v-if="form.dis_status == 2">举例：商品100元，抵扣{{ getPrice(100*(1-form.discounts/100)) }}元</span>

         </div>

         <div>如果优惠金额超过视频的价格，购买时，统一0元购买处理</div>
        
      </el-form-item> -->


    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading">确 定</el-button>
    </div>

  
  </el-dialog>
    

    <GetUser :is_open="open_user" :multi="false" @close="closeDialogFunc"></GetUser>
   </div>
</template>

<script>

  import ShareholderApi from '@/api/shareholder.js';
  import RelationProduct from './Relationproduct';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {

      RelationProduct,
      /*产品列表组件*/

      GetUser,
    },
    data() {
      return {
        form: {
          status:1,
          upgrade_goods_id:[],
          product:[],
          discounts:0,
          dis_status:2,
          user_id:"",
   
        },

        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,

        content:'',//备注

        user_info:{
        avatarUrl:"",
        nickName:""
      },
      open_user:false,

      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
   
    },
    methods: {
       roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,2)
      },
      /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_user = false;
      },
      remove(){
        console.log("移除");
        this.user_info = {
          nickName:"",
          avatarUrl:""
        }
        this.form.user_id = "";
      },

      /*添加等级*/
      addGrade() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            var product = params.product;
            if(typeof product == "string"){
              product = JSON.parse(product);
            }
            params.product = JSON.stringify(product);
            ShareholderApi.addShareholder(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                if(typeof product == "string"){
                  params.product = JSON.parse(  params.product);
                }
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },


    }
  };
</script>

<style scoped="scoped">
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/shareholder/index/add.vue